import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconStableVoice: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"stable-voice, stable-volume, voice-circle, voice-control"} maskId="square-filled-radius-0-stroke-1-IconStableVoice"><path fillRule="evenodd" clipRule="evenodd" d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM10 17H11V7H10V17ZM13 15H14V9H13V15ZM7 14H8V10H7V14ZM16 10V14H17V10H16Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconStableVoice;
